(() => {
  if (window.drboIntroQuickAdd) return;
  window.drboIntroQuickAdd = true;
  const language = document.documentElement.lang.split('-')[0];
  const copy = {
    de: {
      pending: 'Wird zum Warenkorb hinzugefügt …',
      success: 'Der Artikel wurde zum Warenkorb hinzugefügt.',
      rejected: 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.',
      uncertain: 'Das Hinzufügen konnte nicht bestätigt werden. Prüfe bitte Deinen Warenkorb, bevor Du es erneut versuchst.'
    },
    en: {
      pending: 'Adding to cart ...',
      success: 'The item has been added to your cart.',
      rejected: 'The item could not be added. Please try again.',
      uncertain: 'We could not confirm whether the item was added. Please check your cart before trying again.'
    },
    nl: {
      pending: 'Wordt aan de winkelwagen toegevoegd …',
      success: 'Het artikel is aan je winkelwagen toegevoegd.',
      rejected: 'Het artikel kon niet worden toegevoegd. Probeer het opnieuw.',
      uncertain: 'We konden niet bevestigen of het artikel is toegevoegd. Controleer je winkelwagen voordat je het opnieuw probeert.'
    }
  }[language] || null;
  if (!copy) return;
  // Mark these AJAX forms as handled before Shopify's native form-submit tracking.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-intro-cart-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const region = form.closest('[data-intro-purchase]');
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const status = region.querySelector('[data-intro-cart-status]');
    const cartLink = region.querySelector('[data-intro-cart-link]');
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.hidden = false;
    status.textContent = copy.pending;
    cartLink.hidden = true;
    let confirmed = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: 1 }] }),
        signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok) {
        const error = new Error('Cart rejected');
        error.customerMessage = typeof result.description === 'string' ? result.description : copy.rejected;
        throw error;
      }
      if (!result.items?.some(item => String(item.variant_id || item.id) === form.elements.id.value && item.quantity > 0)) throw new Error('Unconfirmed cart response');
      confirmed = true;
      status.textContent = copy.success;
      cartLink.hidden = false;
    } catch (error) {
      status.textContent = error.customerMessage || copy.uncertain;
      cartLink.hidden = false;
    } finally {
      clearTimeout(timeout);
      delete form.dataset.pending;
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
    if (!confirmed) return;
    // Keep the site's existing cart drawer and counter in sync without adding again.
    try {
      const response = await fetch(`${cartLink.href}.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const cart = await response.json();
        if (window.themeCore) window.themeCore.cartObject = cart;
        window.themeCore?.EventBus?.emit('header:update-item-count', { item_count: cart.item_count });
      }
      window.themeCore?.EventBus?.emit('cart:refresh');
    } catch (_) {
      // The add was confirmed; the cart link remains usable if UI refresh fails.
    }
  }, { capture: true });
})();
